import DepartmentEnum from '../../../Enums/DepartmentEnum';
import FreelancerActiveStatusEnum from '../../../Enums/FreelancerActiveStatusEnum';
import FreelancerAgencyUserTypesEnum from '../../../Enums/FreelancerAgencyUserTypesEnum';
import FreelancerUserPaymentMethodEnum from '../../../Enums/FreelancerUserPaymentMethodEnum';
import WiseTransferMethodEnum from '../../../Enums/WiseTransferMethodEnum';
import FreelancerUserService from '../../../Services/FreelancerUserService';
import FreelancerUserSearchParams from './FreelancerUserSearchParams';

class EditFreelancerUserHelper {
  //#region  Default Value
  static getDefaultInvoiceNeededValue(editedItem) {
    switch (editedItem.OfficeId.toString()) {
      case '1': //USA
        return false;
      case '2': //Belgium
      case '9': //Hungary
      case '12': //Spain
        return true;
      case '4': //Brazil
        return !editedItem.FreelancerRoleIds.some(
          (roleId) =>
            roleId.toString() === DepartmentEnum.RM.toString() || roleId.toString() === DepartmentEnum.DQ.toString()
        );
      case '5': //India
        return !editedItem.IsEmployee;
      case '6': //China
        return !editedItem.IsEmployee && editedItem.UserType === FreelancerAgencyUserTypesEnum.Agency;
      case '7': //Chile
        return false;
      case '8': //Singapore
        return true;
      case '13': //Dubai
        return true;
      case '14': //Mexico
        return true;
      default:
        break;
    }
    return editedItem.InvoiceNeeded;
  }

  static getDefaultBillingCurrencyValue(editedItem) {
    switch (editedItem.OfficeId.toString()) {
      case '1': //USA
        return 151;
      case '2': //Belgium
      case '9': //Hungary
      case '12': //Spain
        return 45;
      case '4': //Brazil
        return 20;
      case '5': //India
        return 65;
      case '6': //China
        return 30;
      case '7': //Chile
        return 29;
      case '8': //Singapore
        return 128;
      case '13': //Dubai
        return 1;
      case '14': //Mexico
        return 101;
      default:
        break;
    }
    return null;
  }

  static getDefaultPaymentCurrencyValue(editedItem) {
    const officeId = editedItem.PaymentOfficeId ? editedItem.PaymentOfficeId : editedItem.OfficeId;

    switch (officeId.toString()) {
      case '1': //USA
        return 151;
      case '2': //Belgium
      case '9': //Hungary
      case '12': //Spain
        return 45;
      case '4': //Brazil
        return 20;
      case '5': //India
        return 65;
      //China
      case '6': {
        if (
          editedItem.UserType === FreelancerAgencyUserTypesEnum.IndependentUser &&
          editedItem.PaymentMethod === FreelancerUserPaymentMethodEnum.AliPay
        ) {
          return 30;
        } else if (
          editedItem.UserType === FreelancerAgencyUserTypesEnum.Agency &&
          !['30', '151', '45'].includes(editedItem.PaymentCurrencyId.toString())
        ) {
          return 30;
        } else {
          return editedItem.PaymentCurrencyId ? editedItem.PaymentCurrencyId : 30;
        }
      }
      //Chile
      case '7': {
        if (editedItem.ContractorLocationCountryId?.toString() === '44') {
          return 29;
        } else {
          return 151;
        }
      }
      case '8': //Singapore
        return 128;
      case '13': //Dubai
        return 1;
      //Mexico
      case '14': {
        if (editedItem.ContractorLocationCountryId?.toString() === '142') {
          return [101];
        } else {
          return [151];
        }
      }
      default:
        break;
    }
    return null;
  }

  static getDefaultPaymentMethodValue(editedItem) {
    const officeId = editedItem.PaymentOfficeId ? editedItem.PaymentOfficeId : editedItem.OfficeId;

    switch (officeId.toString()) {
      case '1': //USA
        return FreelancerUserPaymentMethodEnum.Tipalti;
      case '2': //Belgium
      case '9': //Hungary
      case '12': //Spain
        return null;
      case '4': //Brazil
        return FreelancerUserPaymentMethodEnum.BankTransfer;
      case '5': //India
        return null;
      //China
      case '6': {
        if (
          editedItem.UserType === FreelancerAgencyUserTypesEnum.IndependentUser &&
          editedItem.PaymentMethod === FreelancerUserPaymentMethodEnum.BankTransfer
        ) {
          return FreelancerUserPaymentMethodEnum.AliPay;
        } else if (editedItem.UserType === FreelancerAgencyUserTypesEnum.Agency) {
          return FreelancerUserPaymentMethodEnum.BankTransfer;
        } else return null;
      }
      //Chile
      case '7': {
        if (editedItem.ContractorLocationCountryId?.toString() === '44') {
          return FreelancerUserPaymentMethodEnum.BankTransfer;
        }
        return null;
      }
      case '8': //Singapore
        return null;
      case '13': //Dubai
        return null;
      case '14': //Mexico
        return FreelancerUserPaymentMethodEnum.BankTransfer;
      default:
        break;
    }
    return null;
  }

  static getDefaultAgencyUserType(editedItem) {
    if (editedItem.UserType === FreelancerAgencyUserTypesEnum.Agency) {
      if (editedItem.FreelancerRoleIds && editedItem.FreelancerRoleIds.length > 0) {
        return FreelancerAgencyUserTypesEnum.Agency;
      }
      return FreelancerAgencyUserTypesEnum.IndependentUser;
    }
    return editedItem.UserType;
  }
  //#endregion

  //#region  Select Options
  static getPaymentMethodSelectOptions(editedItem) {
    const officeId = parseInt(
      editedItem.PaymentOfficeId ? editedItem.PaymentOfficeId : editedItem.OfficeId ? editedItem.OfficeId : 0
    );

    const res = [];
    res.push({
      label: 'Choose one...',
      value: '',
      disabled: true,
    });

    if ([0, 1].includes(officeId)) {
      res.push({
        label: 'Tipalti',
        value: FreelancerUserPaymentMethodEnum.Tipalti,
        disabled: officeId === 0,
      });
    }

    if ([0, 6].includes(officeId)) {
      res.push({
        label: 'AliPay',
        value: FreelancerUserPaymentMethodEnum.AliPay,
        disabled: officeId === 0 || (officeId === 6 && editedItem.UserType === FreelancerAgencyUserTypesEnum.Agency),
      });
    }

    if ([0, 2, 4, 5, 6, 7, 8, 9, 12, 13, 14].includes(officeId)) {
      res.push({
        label: 'Bank Transfer',
        value: FreelancerUserPaymentMethodEnum.BankTransfer,
        disabled:
          officeId === 0 ||
          (officeId === 6 && editedItem.UserType === FreelancerAgencyUserTypesEnum.IndependentUser) ||
          (officeId === 7 &&
            (!editedItem.ContractorLocationCountryId || editedItem.ContractorLocationCountryId !== 44)),
      });
    }

    if ([0, 2, 6, 7, 9, 13].includes(officeId)) {
      res.push({
        label: 'PayPal',
        value: FreelancerUserPaymentMethodEnum.PayPal,
        disabled:
          officeId === 0 ||
          (officeId === 6 && editedItem.UserType === FreelancerAgencyUserTypesEnum.Agency) ||
          (officeId === 7 &&
            (!editedItem.ContractorLocationCountryId || editedItem.ContractorLocationCountryId === 44)),
      });
    }

    if ([0, 2, 9].includes(officeId)) {
      res.push({
        label: 'Wise',
        value: FreelancerUserPaymentMethodEnum.Wise,
        disabled: officeId === 0,
      });
    }

    if ([0, 7].includes(officeId)) {
      res.push({
        label: 'Western Union',
        value: FreelancerUserPaymentMethodEnum.WesternUnion,
        disabled:
          officeId === 0 ||
          (officeId === 7 &&
            (!editedItem.ContractorLocationCountryId || editedItem.ContractorLocationCountryId === 44)),
      });
    }

    if ([0, 8].includes(officeId)) {
      res.push({
        label: 'Pay Now',
        value: FreelancerUserPaymentMethodEnum.PayNow,
        disabled: officeId === 0,
      });
    }

    return res;
  }

  static getSelectOptionsForWiseTransferMethod() {
    return [
      { label: 'Choose one...', value: '', disabled: true },
      { label: 'Source Currency', value: WiseTransferMethodEnum.SourceCurrency, disabled: false },
      { label: 'Target Currency', value: WiseTransferMethodEnum.TargetCurrency, disabled: false },
    ];
  }

  static getSelectOptionsForUserType() {
    return [
      { label: 'Independent User', value: FreelancerAgencyUserTypesEnum.IndependentUser, disabled: false },
      { label: 'User With Agency', value: FreelancerAgencyUserTypesEnum.UserWithAgency, disabled: false },
      { label: 'Agency', value: FreelancerAgencyUserTypesEnum.Agency, disabled: false },
    ];
  }

  static getSelectOptionsForActiveStatus() {
    return [
      { label: 'Active - Engaged', value: FreelancerActiveStatusEnum.ActiveEngaged, disabled: false },
      { label: 'Inactive - Not Engaged', value: FreelancerActiveStatusEnum.InactiveNotEngaged, disabled: false },
      { label: 'Inactive - Offboarded', value: FreelancerActiveStatusEnum.InactiveOffboarded, disabled: false },
    ];
  }
  //#endregion

  //#region Validity Checkers
  static validityCheckerDataExistsInDatabase(fieldInTable, value, errorMessage, freelancerUserId) {
    const searchparams = new FreelancerUserSearchParams();
    searchparams.OfficeName = '';
    searchparams[fieldInTable] = value.toString();
    return FreelancerUserService.GetFreelancerUserList('', '', 1, 2, searchparams).then((result) => {
      if (result.data.length === 0 || result.data[0].freelancerUserId === freelancerUserId) {
        return '';
      }
      return `${errorMessage} (${result.data[0].firstName} ${result.data[0].lastName})`;
    });
  }
  //#endregion

  static checkPaymentMethodDoesExistForThisOffice(editedItem) {
    const pm = editedItem.PaymentMethod;
    const officeId = editedItem.PaymentOfficeId ? editedItem.PaymentOfficeId : editedItem.OfficeId;

    const opt = EditFreelancerUserHelper.getPaymentMethodSelectOptions(officeId).find((o) => o.value === pm);
    if (opt) {
      return pm;
    }
    return '';
  }

  static isBillingDetailHidden(editedItem, requiredOfficeId) {
    const officeId = (editedItem.PaymentOfficeId ? editedItem.PaymentOfficeId : editedItem.OfficeId).toString();

    if (editedItem.UserType === FreelancerAgencyUserTypesEnum.UserWithAgency) {
      return true;
    }

    if (Array.isArray(requiredOfficeId)) {
      return !requiredOfficeId.some((x) => x?.toString() === officeId.toString());
    }
    return officeId !== requiredOfficeId?.toString();
  }

  static isBillingDetailFieldHidden(editedItem, acceptedPaymentMethod) {
    if (Array.isArray(acceptedPaymentMethod)) {
      return !acceptedPaymentMethod.some((x) => x?.toString() === editedItem.PaymentMethod?.toString());
    }
    return editedItem.PaymentMethod?.toString() !== acceptedPaymentMethod?.toString();
  }
}

export default EditFreelancerUserHelper;
